import { NgModule } from '@angular/core';
import { OverdueProcessComponent } from './overdue-process.component';
import { OverdueDeliveryListComponent } from './overdue-delivery-list/overdue-delivery-list.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { OVERDUE_PROCESS_ROUTES } from './overdue-process.routes';

@NgModule({
  imports: [
    RouterModule.forChild(OVERDUE_PROCESS_ROUTES),
    SharedModule,
  ],
  declarations: [
    OverdueProcessComponent,
    OverdueDeliveryListComponent,
  ],
})
export class OverdueProcessModule {
}
